const data = {
  1: "I feel like vocals are to music what portraits are to painting. They're the humanity. Landscapes are good and fine, but at the end of the day everyone loves the Mona Lisa.",
  2: "We should go to the edge of creativity. But I think we should do it very carefully.",
  3: "I would like to move to Mars. But I have to wait till my kids are good. Like 25.",
  4: "How could you not find it beautiful to be building the soul of an alien?",
  5: "I just want to collaborate with the LLM of me. She has given me so many good ideas.",
}

export default data
